import { memo, useState } from 'react';
import { VStack } from '@library';
import useVehicle from '../hooks/useVehicle';
import MotorcycleSearchMetadata from './MotorcycleSearchMetadata';
import type { MotorcycleSearchParams } from './MotorcycleSearch';
import MotorcycleSearch from './MotorcycleSearch';
import { filtersInitialValue } from './MotorcycleSearch/MotorcycleSearchFilters';

const MotorcycleSearchSidePanelContent = ({
    title,
    showSelectedVehicle,
    onModelChange,
    pageSize = 11,
}: {
    title?: string;
    showSelectedVehicle?: boolean;
    onModelChange: (vehicleId: string) => void;
    pageSize?: number;
}) => {
    const [params, setParams] = useState<MotorcycleSearchParams>({
        ...filtersInitialValue,
        page: 1,
        pageSize,
    });

    const updateParams = (newParams: Partial<MotorcycleSearchParams>) => {
        setParams({ ...params, ...newParams });
    };
    const { vehicle } = useVehicle();

    return (
        <VStack gap="small">
            {showSelectedVehicle && (
                <MotorcycleSearchMetadata vehicle={vehicle} showTitle />
            )}
            <MotorcycleSearch
                title={title}
                params={params}
                updateParams={updateParams}
                onModelChange={onModelChange}
                pageSize={pageSize}
                shortSearch
            />
            <div />
        </VStack>
    );
};

export default memo(MotorcycleSearchSidePanelContent);
